import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import {
  AllProductCategoryQuery,
  getProductcategory,
} from "../../lib/graphQL/graphQuery";
import { DeleteCategoryMutation } from "../../lib/graphQL/graphMutation";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function CategoryListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const { circleLoading, setCirleLoading } = useLoading();

  const categoryListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Category ID",
        field: "catid",
        name: "Category id",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Category Name",
        field: "categoryName",
        name: "Category Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: categoryData.reverse().map((item, index) => ({
      sno: index + 1,
      id: item.id,
      catid: item.catid,
      categoryName: item.categoryName,
      createdBy: item.user.username,
      createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
    })),
  };

  const fetchCategoryData = () => {
    setIsLoading(true);
    request(BASEURL, AllProductCategoryQuery)
      .then((res) => {
        setCategoryData(res.allProductcategory);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchCategoryData();
    setStatus(false);
  }, [id, status]);

  const handleNewCategory = () => {
    navigate("/category/add-category");
  };

  const onRoleListClick = (e) => {
    if (e?.id) {
      navigate(`/category/add-category?${e?.id}`);
    }
  };

  const onDelete=(id)=>
    {
      console.log("id-d",id)
    }
    
    const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
    const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={categoryListTable.columns}
      rowsData={categoryListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Category List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onRoleListClick}
      // onDelete={onDelete}
      onView={onRoleListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewCategory()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Category List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewCategory()}
              >
                Add Category
              </MaterialButton>
            </Stack>
          }
        />
       {!isLoading &&<MaterialDataGrid
          // customHeight={550}
          rows={categoryListTable.rows}
          columns={categoryListTable.columns}
          // checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRoleListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Category found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Category details. Click on the "Add
                  Category" button to start adding Category details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />}
         {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
